// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-container[data-v-12ace26c]{max-width:1080px;margin:0 auto}.single-input-container[data-v-12ace26c]{max-width:480px}.close-btn[data-v-12ace26c]{position:absolute;right:1.5rem;top:1rem;font-size:1.1rem}", ""]);
// Exports
module.exports = exports;
